var _path, _path2, _path3;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTimer = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 14.8333C4.69072 14.8333 1.99996 12.1426 1.99996 8.83333C1.99996 5.5241 4.69072 2.83333 7.99996 2.83333C11.3092 2.83333 14 5.5241 14 8.83333C14 12.1426 11.3092 14.8333 7.99996 14.8333ZM7.99996 3.16667C4.87586 3.16667 2.33329 5.70924 2.33329 8.83333C2.33329 11.9574 4.87586 14.5 7.99996 14.5C11.1241 14.5 13.6666 11.9574 13.6666 8.83333C13.6666 5.70924 11.1241 3.16667 7.99996 3.16667Z",
    fill: "#455CC7",
    stroke: "#455CC7",
    strokeWidth: 0.666667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.16659C7.72667 9.16659 7.5 8.93992 7.5 8.66659V5.33325C7.5 5.05992 7.72667 4.83325 8 4.83325C8.27333 4.83325 8.5 5.05992 8.5 5.33325V8.66659C8.5 8.93992 8.27333 9.16659 8 9.16659Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.83325H6C5.72667 1.83325 5.5 1.60659 5.5 1.33325C5.5 1.05992 5.72667 0.833252 6 0.833252H10C10.2733 0.833252 10.5 1.05992 10.5 1.33325C10.5 1.60659 10.2733 1.83325 10 1.83325Z",
    fill: "#455CC7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/timer.45facbe7.svg";
export { ForwardRef as ReactComponent };